import { extend } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'
import isEmpty from 'lodash/isEmpty'

extend('required', required)
extend('max', max)

const customValidationRules = {
  emailEnglishNoSpace: {
    validate: (value) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return regex.test(value) && !/\s/.test(value)
    },
    message: 'Email must contain only English characters and no spaces.',
  },
  nameEnglishOnly: {
    validate: (value) => {
      return /^[A-Za-z\s.'-]+$/.test(value)
    },
    message: 'Name must contain only English letters and spaces.',
  },
}

extend('emailEnglishNoSpace', customValidationRules.emailEnglishNoSpace)
extend('nameEnglishOnly', customValidationRules.nameEnglishOnly)

export default {
  methods: {
    hasError(errors) {
      return !isEmpty(errors)
    },
  },
  customValidationRules,
}
